import { useEffect } from "react";
import { useSelector } from "react-redux";
import { registerGoogleAnalyticsEvent } from "./googleTagManagerDataLayer";
import { StringParam, useQueryParams } from "use-query-params";

export const GooglePageViewTypes = Object.freeze({
  NOT_FOUND: "404",
  ACCOUNT: "account",
  CART: "cart",
  // CONTENT_BLOG_NEWS: "content / blog / news",
  CONTENT: "content",
  BLOG: "blog",
  NEWS: "news",
  HOME: "home",
  PRODUCT: "product",
  PRODUCT_LISTING: "product listing",
  SEARCH: "search",
  THANK_YOU: "thankyou"
});


const useFinalGAnalyticsPageType = (googleAnalyticsPageType) => {

  const paramConfigMap = { q: StringParam }
  const [queryParams] = useQueryParams(paramConfigMap)
  const searchTerm = queryParams?.q

  if(googleAnalyticsPageType !== GooglePageViewTypes.PRODUCT_LISTING) return googleAnalyticsPageType

  return searchTerm ? GooglePageViewTypes.SEARCH : GooglePageViewTypes.PRODUCT_LISTING
}

export const useGAnalyticsPageData = ({ googleAnalyticsPageType, finalTitle }) => {

  const finalGAnalyticsPageType = useFinalGAnalyticsPageType(googleAnalyticsPageType)

  const userId = useSelector(state => state?.auth?.userData?.role?.user?.id);

  return {
    event: "virtualPageView",
    page: {
      title: finalTitle?.toLowerCase?.(),
      pageType: finalGAnalyticsPageType?.toLowerCase?.(),
      customerNumber: userId,
      url: window?.location?.href,
    }
  }
}
